import { withTrackedReducer } from '@angular-architects/ngrx-toolkit';
import { VesselParticularsStoreState } from '@navstation-portal/vessels/data-model/vessel';
import { signalStoreFeature } from '@ngrx/signals';
import { on } from '@ngrx/signals/events';
import { vesselParticularsEvents } from './vessel-particulars-events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withVesselParticularsReducer<_>() {
  return signalStoreFeature(
    withTrackedReducer(
      on(
        vesselParticularsEvents.fetchVesselParticulars,
        (): Partial<VesselParticularsStoreState> => ({
          isFetchingVesselParticulars: true,
          fetchError: undefined,
        })
      ),
      on(
        vesselParticularsEvents.fetchVesselParticularsSuccess,
        ({ payload: vesselParticulars }): Partial<VesselParticularsStoreState> => ({
          vesselParticulars,
          isFetchingVesselParticulars: false,
        })
      ),
      on(
        vesselParticularsEvents.fetchVesselParticularsFailed,
        ({ payload: error }): Partial<VesselParticularsStoreState> => ({
          vesselParticulars: undefined,
          isFetchingVesselParticulars: false,
          fetchError: error.message,
        })
      )
    )
  );
}
